import { styled } from '@mui/material';

import { getShouldForwardPropFn } from '@mopla/utils';

interface IStyledDivProps {
	disabled?: boolean;
}

export const StyledDiv = styled('div', {
	shouldForwardProp: getShouldForwardPropFn<IStyledDivProps>('disabled'),
})<IStyledDivProps>(({ theme, disabled }) => ({
	width: '100%',
	aspectRatio: '1',
	display: 'flex',
	borderRadius: '50%',
	alignItems: 'center',
	justifyContent: 'center',

	'&>svg': {
		width: 16,
		height: 16,
		color: disabled ? theme.palette.neutral[60] : theme.palette.primary.main,
	},
}));
